// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2I4Ye","inputWrap":"styles_inputWrap__18LCN","input":"styles_input__2nCM8"};